
import { ClaimRequest } from './ClaimRequestInterface';
import EmptyClaimRequests from './EmptyClaimRequests';
import ProcessedClaimRequestCard from './ProcessedClaimRequestCard';

interface ProcessedClaimsTabProps {
  requests: ClaimRequest[];
  isLoading: boolean;
}

const ProcessedClaimsTab = ({ requests, isLoading }: ProcessedClaimsTabProps) => {
  return (
    <div className="space-y-4">
      {isLoading || requests.length === 0 ? (
        <EmptyClaimRequests isLoading={isLoading} type="processed" />
      ) : (
        requests.map(request => (
          <ProcessedClaimRequestCard key={request.id} request={request} />
        ))
      )}
    </div>
  );
};

export default ProcessedClaimsTab;
